// extracted by mini-css-extract-plugin
export default {"toolTipArea":"Tooltipper_toolTipArea__YWviw","toolTipNoEvents":"Tooltipper_toolTipNoEvents__8HN9A","toolTipAreaLarge":"Tooltipper_toolTipAreaLarge__EnUst"};